module.exports = __webpack_public_path__ + "img/warning_24px.58e4997a.svg";